import type { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const WatchListStyles = makeStyles((theme: Theme) =>
  createStyles({
    gains: {
      color: "#01C0AA",
      fontSize: "14px",
      textAlign: "center",
    },
    loses: {
      color: "red",
      fontSize: "14px",
      textAlign: "center",
    },
    link: {
      margin: 0,
      color: theme.palette.secondary.main,
      fontWeight: 600,
      fontSize: "1rem",
      lineHeight: 1.5,
    },
    "@keyframes bellshake": {
      " 0%": { transform: "rotate(0)" },
      "15%": { transform: "rotate(5deg)" },
      "30%": { transform: "rotate(-5deg)" },
      " 45% ": { transform: "rotate(4deg)" },
      "60%": { transform: "rotate(-4deg)" },
      " 75% ": { transform: "rotate(2deg) " },
      " 85% ": { transform: " rotate(-2deg)" },
      "92% ": { transform: "rotate(1deg)" },
      "100% ": { transform: "rotate(0)" },
    },
    notificationIcon: {
      "&:hover": {
        animation: `$bellshake .5s cubic-bezier(.36,.07,.19,.97) both`,
        backfaceVisibility: "hidden",
        transformOrigin: "top right",
      },
    },
    headerTitle: {
      fontSize: "16px",
      fontWeight: theme.typography.fontWeightMedium,
    },
    tableCell: {
      fontSize: "16px",
      paddingTop: "6px",
      paddingBottom: "0px",
      borderBottom: "1px",
    },
    coinCell: {
      alignItems: "center",
    },
    container: {
      boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;",
      borderRadius: "15px",
      padding: "20px 5px 20px 25px",
      [theme.breakpoints.up("md")]: {
        padding: "10px 0px 20px 16px",
      },
    },
    icon: {
      width: "30px",
      height: "30px",
      borderRadius: "50%",
      margin: "8px 0px",
      marginRight: "20px",
    },
    title: {
      fontSize: "26px",
      fontWeight: theme.typography.fontWeightMedium,
      [theme.breakpoints.up("md")]: {
        padding: "10px 0px 10px 15px",
      },
    },
    name: {
      fontSize: "20px",
      marginLeft: "4px",
      fontWeight: theme.typography.fontWeightMedium,
      [theme.breakpoints.up("md")]: {
        fontSize: "16px",
        marginLeft: "6px",
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    subtitle: {
      fontSize: "14px",
      marginLeft: "6px",
      fontWeight: theme.typography.fontWeightRegular,
      [theme.breakpoints.up("md")]: {
        fontSize: "16px",
        fontWeight: theme.typography.fontWeightRegular,
      },
    },
    values: {
      textAlign: "right",
      fontSize: "20px",
    },
    subvalueContainer: {
      justifyContent: "flex-end",
    },
    listItems: {
      paddingLeft: "0px",
      paddingRight: "0px",
      cursor: "pointer",
      "&:hover": {
        backgroundColor: "#E8E8E8",
        color: "black",
        "& .MuiListItemIcon-root": {
          color: "white",
        },
      },
    },
    subvalueIcon: {
      paddingRight: "2px",
    },
    positive: {
      color: "#01C0AA",
    },
    negative: {
      color: "#EA0C01",
    },
    hideOnDesktop: {
      [theme.breakpoints.up("md")]: {
        display: "none",
      },
    },
    hideOnMobile: {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
    tableRow: {
      cursor: "pointer",
    },
    scrollbarContainer: {
      overflowY: "scroll",
      maxHeight: "300px",
      paddingRight: "20px",
      [theme.breakpoints.up("md")]: {
        paddingRight: "0px",
        maxHeight: "350px",
      },
    },
  }),
);
